/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Fade from "@mui/material/Fade";

// Material Dashboard 2 React base styles
import colors from "assets/theme-dark/base/colors";
import typography from "assets/theme-dark/base/typography";
import borders from "assets/theme-dark/base/borders";

// Material Dashboard 2 React helper functions
import pxToRem from "assets/theme-dark/functions/pxToRem";

const { white } = colors;
const { size, fontWeightRegular } = typography;
const { borderRadius } = borders;

// Redesign: elevated dark tooltip (kept dark in both themes), 12px, small radius.
const tooltip = {
  defaultProps: {
    arrow: true,
    TransitionComponent: Fade,
  },

  styleOverrides: {
    tooltip: {
      maxWidth: pxToRem(240),
      backgroundColor: "#28323F",
      color: white.main,
      fontSize: size.xs,
      fontWeight: fontWeightRegular,
      textAlign: "center",
      borderRadius: borderRadius.sm,
      opacity: 1,
      padding: `${pxToRem(6)} ${pxToRem(10)}`,
    },

    arrow: {
      color: "#28323F",
    },
  },
};

export default tooltip;
